import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "../../../styles/pages/profile/ProfilePage.module.css";

const FollowRequestsViewSkeleton = () => {
  return (
    <div className={styles.contentSection}>
      <div className={styles.sectionHeader}>
        <div>
          <Skeleton height={32} width="200px" style={{ marginBottom: "10px" }} />
          <Skeleton height={18} width="150px" />
        </div>
        <Skeleton height={40} width={100} borderRadius={8} />
      </div>
      <div className={styles.requestsList}>
        {[1, 2, 3].map((i) => (
          <div key={i} className={styles.requestCard}>
            <div className={styles.requestUserInfo}>
              <Skeleton circle height={60} width={60} />
              <div style={{ flex: 1, marginLeft: "15px" }}>
                <Skeleton height={20} width="150px" style={{ marginBottom: "5px" }} />
                <Skeleton height={16} width="100px" />
              </div>
            </div>
            <div className={styles.requestActions}>
              <Skeleton height={36} width={90} borderRadius={8} />
              <Skeleton height={36} width={90} borderRadius={8} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FollowRequestsViewSkeleton;
